var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-wrapper" }, [
    _c("div", { staticClass: "exchange_content" }, [
      _c(
        "div",
        { staticClass: "exchange_ipt" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.couponcode,
                expression: "couponcode"
              }
            ],
            attrs: { type: "text", placeholder: "请输入优惠码" },
            domProps: { value: _vm.couponcode },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.couponcode = $event.target.value
                },
                _vm.checkCode
              ]
            }
          }),
          _vm._v(" "),
          !_vm.disabledFlag
            ? _c("van-icon", {
                attrs: { name: "clear" },
                on: { click: _vm.clearInput }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "exchange_btn",
              class: { disabled: _vm.disabledFlag },
              attrs: { disabled: _vm.disabledFlag },
              on: { click: _vm.changecoupon }
            },
            [_vm._v("\n        兑换\n      ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.vip_coupon_num !== 0 && _vm.vip_coupon_num !== -1
        ? _c("p", { staticClass: "all_tab" }, [
            _c(
              "span",
              {
                class: { all_index: _vm.allIndex == 1 },
                on: {
                  click: function($event) {
                    return _vm.checkAllTab(1)
                  }
                }
              },
              [_vm._v("全部(" + _vm._s(_vm.all_coupon_num) + ")")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: { all_index: _vm.allIndex == 2 },
                on: {
                  click: function($event) {
                    return _vm.checkAllTab(2)
                  }
                }
              },
              [_vm._v("会员专属(" + _vm._s(_vm.vip_coupon_num) + ")")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: { all_index: _vm.allIndex == 3 },
                on: {
                  click: function($event) {
                    return _vm.checkAllTab(3)
                  }
                }
              },
              [_vm._v("其他(" + _vm._s(_vm.other_coupon_num) + ")")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "exchange_tab" }, [
        _c(
          "span",
          {
            class: { content_index: _vm.current == 1 },
            on: {
              click: function($event) {
                return _vm.checkUseableTab(1)
              }
            }
          },
          [_vm._v("可使用优惠券(" + _vm._s(_vm.usenum) + ")")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            class: { content_index: _vm.current == 2 },
            on: {
              click: function($event) {
                return _vm.checkUseableTab(2)
              }
            }
          },
          [_vm._v("不可使用优惠券(" + _vm._s(_vm.unusenum) + ")")]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.current == 1
      ? _c("div", [
          _vm.usecouponlist != ""
            ? _c(
                "div",
                { staticClass: "coupon_content" },
                _vm._l(_vm.usecouponlist, function(i, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "coupon_detail" },
                    [
                      _c("p", { staticClass: "coupon_left" }, [
                        _c("span", { staticClass: "coupon_price" }, [
                          _vm._v("￥"),
                          _c("span", [
                            _vm._v(_vm._s(i.coupon.couponMoney / 100))
                          ])
                        ]),
                        _vm._v(" "),
                        i.coupon.withAmount
                          ? _c("span", { staticClass: "coupon_condition" }, [
                              _vm._v(
                                "满" +
                                  _vm._s(i.coupon.withAmount / 100) +
                                  "元使用"
                              )
                            ])
                          : _c("span", { staticClass: "coupon_condition" }, [
                              _vm._v("无使用门槛")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "coupon_center" }, [
                        _c("span", { staticClass: "coupon_name" }, [
                          _vm._v(_vm._s(i.coupon.name))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "validity" }, [
                          _vm._v(
                            "有效期：" +
                              _vm._s(_vm.validFormat(i.coupon.validStartTime)) +
                              " - " +
                              _vm._s(_vm.validFormat(i.coupon.validEndTime))
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "coupon_wrapper" }, [_vm._m(0)])
        ])
      : _vm.current == 2
      ? _c("div", [
          _vm.couponlist != ""
            ? _c(
                "div",
                { staticClass: "coupon_content" },
                _vm._l(_vm.couponlist, function(i, index) {
                  return _c("div", { key: index, staticClass: "coupon_box" }, [
                    _c(
                      "div",
                      { staticClass: "coupon_detail coupon_content_pass" },
                      [
                        _c("p", { staticClass: "coupon_left" }, [
                          _c("span", { staticClass: "coupon_price" }, [
                            _vm._v("￥"),
                            _c("span", [
                              _vm._v(_vm._s(i.coupon.couponMoney / 100))
                            ])
                          ]),
                          _vm._v(" "),
                          i.coupon.withAmount
                            ? _c("span", { staticClass: "coupon_condition" }, [
                                _vm._v(
                                  "满" +
                                    _vm._s(i.coupon.withAmount / 100) +
                                    "元使用"
                                )
                              ])
                            : _c("span", { staticClass: "coupon_condition" }, [
                                _vm._v("无使用门槛")
                              ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "coupon_center" }, [
                          _c("span", { staticClass: "coupon_name" }, [
                            _vm._v(_vm._s(i.coupon.name))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "validity" }, [
                            _vm._v(
                              "有效期:" +
                                _vm._s(
                                  _vm.validFormat(i.coupon.validStartTime)
                                ) +
                                " - " +
                                _vm._s(_vm.validFormat(i.coupon.validEndTime))
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pass_tag" }, [
                      i.isUsed
                        ? _c("span", [_vm._v("优惠码已使用")])
                        : new Date(i.coupon.validStartTime) >
                          new Date().getTime()
                        ? _c("span", [_vm._v("未到可用时间")])
                        : i.reason
                        ? _c("span", [_vm._v(_vm._s(i.reason))])
                        : _c("span", [_vm._v("优惠码已过期")])
                    ])
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "coupon_wrapper" }, [_vm._m(1)])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.show
      ? _c("div", { staticClass: "goods_wrapper" }, [
          _c(
            "div",
            { staticClass: "goods_box" },
            [
              _c("img", {
                staticClass: "closeList",
                attrs: { src: require("../../../static/images/guanbi.png") },
                on: { click: _vm.closeList }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "goods_title" }, [_vm._v("商品列表")]),
              _vm._v(" "),
              _vm.withAmount
                ? _c("p", { staticClass: "goods_rule" }, [
                    _vm._v(
                      "以下商品可使用满" +
                        _vm._s(_vm.withAmount) +
                        "元减" +
                        _vm._s(_vm.couponMoney / 100) +
                        "元的优惠券"
                    )
                  ])
                : _c("p", { staticClass: "goods_rule" }, [
                    _vm._v("以下商品可使用无门槛优惠券")
                  ]),
              _vm._v(" "),
              _c(
                "van-list",
                {
                  attrs: {
                    finished: _vm.finished,
                    "finished-text": "没有更多了",
                    "immediate-check": false
                  },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.loading,
                    callback: function($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading"
                  }
                },
                _vm._l(_vm.goodsList, function(item, index) {
                  return _c("van-cell", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass: "goods_list",
                        on: {
                          click: function($event) {
                            return _vm.goShop(item.url)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "goods_content" }, [
                          _c("img", {
                            attrs: { src: "//s.eoffcn.com/" + item.img }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "goods_detail" }, [
                            _c("p", { staticClass: "goods_name" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "goods_price" }, [
                              _vm._v("¥ "),
                              item.minPrice
                                ? _c("span", [
                                    _vm._v(_vm._s(item.minPrice / 100) + " - ")
                                  ])
                                : _vm._e(),
                              _vm._v(_vm._s(item.maxPrice / 100))
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                }),
                1
              ),
              _vm._v(" "),
              _vm.use.length
                ? _c(
                    "div",
                    { staticClass: "unuse_list" },
                    [
                      _c("p", { staticClass: "goods_rules" }, [
                        _vm._v(
                          "以下商品已参加了其他优惠活动，暂时无法使用优惠券"
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.use, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "goods_list" },
                          [
                            _c("div", { staticClass: "goods_content" }, [
                              _c("img", {
                                attrs: { src: "//s.eoffcn.com/" + item.img }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "goods_detail" }, [
                                _c("p", { staticClass: "goods_name" }, [
                                  _vm._v(_vm._s(item.name))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "goods_price" }, [
                                  _vm._v("¥ "),
                                  item.minPrice
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(item.minPrice / 100) + " - "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(_vm._s(item.maxPrice / 100))
                                ])
                              ])
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: { src: require("../../../static/images/coupon.png") }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无优惠码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: { src: require("../../../static/images/coupon.png") }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无优惠码")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48cce539", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48cce539","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/coupon/index.vue
// module id = null
// module chunks = 